import { AssignmentCheckbox } from '../../AssignmentHelpers/AssignmentCheckbox'
import { AssignmentPopover } from '../../AssignmentHelpers/AssignmentPopover'
import {
  UndoOwnDialogue,
  StageCompleteDialogue,
  FutureStageDialogue,
} from '../../AssignmentHelpers/AssignmentPopover/dialogues'
import { TaskProps } from '../types'

type TaskCheckboxKeys =
  | 'checked'
  | 'completedAt'
  | 'disableCheckbox'
  | 'phaseIsComplete'
  | 'phaseIsCurrent'
  | 'iconName'
  | 'dueDate'
  | 'taskText'
  | 'onCheckboxClick'

type TaskCheckboxProps = Pick<TaskProps, TaskCheckboxKeys>

export const TaskCheckbox: React.FC<TaskCheckboxProps> = ({
  checked,
  completedAt,
  disableCheckbox,
  iconName,
  dueDate,
  phaseIsComplete,
  taskText,
  phaseIsCurrent,
  onCheckboxClick,
}) => {
  let dialogueElement = null

  const phaseIsFuture = !phaseIsComplete && !phaseIsCurrent

  if (phaseIsComplete) dialogueElement = <StageCompleteDialogue />
  if (phaseIsFuture) dialogueElement = <FutureStageDialogue />
  if (phaseIsCurrent && completedAt instanceof Date) {
    dialogueElement = (
      <UndoOwnDialogue
        completedAt={completedAt}
        toggleTaskCompletion={onCheckboxClick}
      />
    )
  }

  if (dialogueElement === null) {
    return (
      <AssignmentCheckbox
        checked={checked}
        label={taskText}
        dueDate={dueDate}
        isMoment={iconName === 'moment'}
        disabled={disableCheckbox}
        onClick={onCheckboxClick}
      />
    )
  }

  return (
    <AssignmentPopover
      triggerEvent={checked ? 'click' : 'hover'}
      trigger={
        <AssignmentCheckbox
          checked={checked}
          disabled={disableCheckbox}
          dueDate={dueDate}
          isMoment={iconName === 'moment'}
          label={taskText}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClick={(): void => {}}
        />
      }
    >
      {dialogueElement}
    </AssignmentPopover>
  )
}
